import React from "react";
import Loader from "react-loader-spinner";

import "./styles.css";

export const Loading = () => (
  <div className="loader">
    <Loader type="Bars" color="#4f5d73" height={100} width={100} />
  </div>
);

const LoadableWrapper = (shouldLoad) => (WrappedComponent) => {
  const Loadable = (props) =>
    shouldLoad(props) ? <Loading /> : <WrappedComponent {...props} />;
  return Loadable;
};

export default LoadableWrapper;
